import { Button, ButtonRow } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import type { IHsdqQuestion } from '../NewHsdqQuestionnaire';
import { hsdqQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step3(props: IQuestionnaireFormProps) {
    const questions: IHsdqQuestion[] = [
        {
            key: 'kickingLegMovements',
            label: 'Tijdens mijn slaap heb ik last van schoppende beenbewegingen die ik onmogelijk kan onderdrukken',
            number: 11,
        },
        {
            key: 'concerned',
            label: 'Ik maak me zorgen over de gevolgen van mijn slechte slaap (bijvoorbeeld voor mijn gezondheid)',
            number: 12,
        },
        {
            key: 'troublesFallingAsleep',
            label: 'Ik kan ’s avonds moeilijk in slaap komen',
            number: 13,
        },
        {
            key: 'consequencesAfterBadNight',
            label: 'Vooral na een slechte nacht heb ik overdag last van 1 of meer van deze gevolgen: vermoeidheid, slaperigheid, slecht humeur, zwakke concentratie, geheugenproblemen, gebrek aan energie',
            number: 14,
        },
        {
            key: 'iDontGetEnoughSleep',
            label: 'Ik krijg onvoldoende slaap, ondanks dat ik volop gelegenheid heb om lang te slapen',
            number: 15,
        },
    ];

    return (
        <>
            <PageIntro title="HSDQ: vragen deel 3/7" />

            <CustomContainer>
                {questions.map((question) => {
                    return (
                        <Stack key={question.key}>
                            <Step>{question.number}/32</Step>
                            <StyledFormGroup
                                hasErrors={props.errors.has(question.key)}
                                label={question.label}
                                layout="vertical"
                            >
                                <QuestionnaireRadioGroup
                                    {...props}
                                    customControlData={props.procedure.customControlData}
                                    customControlKey={question.key}
                                    questionnaireOptions={hsdqQuestionOptions}
                                />
                            </StyledFormGroup>
                        </Stack>
                    );
                })}

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
